export const TRACKING_TIME_STATUS = {
  not_checked_in: "休日",
  on_break: "休憩中",
  working: "勤務中",
  checked_out: "出勤",
  not_checked_out: "未終了",
} as const;

export const EXTENDED_TIME_HOUR_COUNT = 48;
export const CHECK_IN_HOUR_COUNT = 24;

export const getTrackingStatusLabel = (
  status?: string | number | null,
): string => {
  if (!status) return TRACKING_TIME_STATUS.not_checked_in;
  const key = String(status) as keyof typeof TRACKING_TIME_STATUS;
  return TRACKING_TIME_STATUS[key] ?? TRACKING_TIME_STATUS.not_checked_in;
};

export type TrackingStatusChipColors = {
  borderColor: string;
  color: string;
  background: string;
};

export const getTrackingStatusChipColors = (
  statusLabel: string,
): TrackingStatusChipColors | undefined => {
  switch (statusLabel) {
    case TRACKING_TIME_STATUS.checked_out:
      return {
        borderColor: "#003cff",
        color: "#003cff",
        background: "#003cff33",
      };
    case TRACKING_TIME_STATUS.on_break:
      return {
        borderColor: "#e7aa1b",
        color: "#e0b12f",
        background: "#e7aa1b33",
      };
    case TRACKING_TIME_STATUS.working:
      return {
        borderColor: "#008000",
        color: "#008000",
        background: "#00800033",
      };
    case TRACKING_TIME_STATUS.not_checked_out:
      return {
        borderColor: "#FF4D4F",
        color: "#FF4D4F",
        background: "#ff4d4f33",
      };
    case TRACKING_TIME_STATUS.not_checked_in:
      return {
        borderColor: "#F0F0F0",
        color: "#D1D1D6",
        background: "#F0F0F0",
      };
    default:
      return undefined;
  }
};

export const formatSecondsToJp = (totalSeconds?: number | null): string => {
  const value = Math.floor(Number(totalSeconds ?? 0));
  if (!Number.isFinite(value) || value <= 0) return "0時間 00分";

  const h = Math.floor(value / 3600);
  const m = Math.floor((value % 3600) / 60);
  return `${h}時間 ${String(m).padStart(2, "0")}分`;
};

export const parsePositiveIntWithDefault = (
  raw: string | null,
  fallback: number,
) => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};
